import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProjectSettingsMembersViewTopBar } from "./TopBar"

export const projectSettingsMembersViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProjectSettingsMembersViewTopBar,
}
